import PropTypes from 'prop-types';
import { useEffect } from 'react';

const SignOut = ({ signOut }) => {
  useEffect(() => {
    signOut();
  }, [signOut]);
  return null;
};

SignOut.propTypes = {
  signOut: PropTypes.func,
};

export default SignOut;
